const normative = Object.freeze({
  'SPANISH CONSTITUTION': { EN: 'Spanish Constitution', ES: 'Constitución Española' },
  'ORGANIC LAW': { EN: 'Organic Law', ES: 'Ley Orgánica' },
  LAW: { EN: 'Law', ES: 'Ley' },
  'FRAMEWORK LAW': { EN: 'Framework Law', ES: 'Ley de Bases' },
  'ROYAL LEGISLATIVE DECREE': { EN: 'Royal Legislative Decree', ES: 'Real Decreto Legislativo' },
  'ROYAL DECREE-LAW': { EN: 'Royal Decree-Law', ES: 'Real Decreto-ley' },
  'ROYAL DECREE': { EN: 'Royal Decree', ES: 'Real Decreto' },
  'LEGISLATIVE DECREE': { EN: 'Legislative Decree', ES: 'Decreto Legislativo' },
  'DECREE-LAW': { EN: 'Decree-Law', ES: 'Decreto-ley' },
  DECREE: { EN: 'Decree', ES: 'Decreto' },
  'MINISTERIAL ORDER': { EN: 'Ministerial Order', ES: 'Orden Ministerial' },
  ORDER: { EN: 'Order', ES: 'Orden' },
  DIRECTIVE: { EN: 'Directive', ES: 'Directiva' },
  REGULATION: { EN: 'Regulation', ES: 'Reglamento' },
  DECISION: { EN: 'Decision', ES: 'Decisión' },
  RECOMMENDATION: { EN: 'Recommendation', ES: 'Recomendación' },
  OPINION: { EN: 'Opinion', ES: 'Dictamen' },
  'INTERNATIONAL TREATY': { EN: 'International Treaty', ES: 'Tratado Internacional' },
  AGREEMENT: { EN: 'Agreement', ES: 'Acuerdo' },
  INSTRUCTION: { EN: 'Instruction', ES: 'Instrucción' },
  RESOLUTION: { EN: 'Resolution', ES: 'Resolución' },
  CIRCULAR: { EN: 'Circular', ES: 'Circular' },
  OTHER: { EN: 'Other', ES: 'Otro' },
});

export default normative;
